<template>
  <div>
    <div class="wrapper flex flex-between">
      <div>
        <breadcrumb :crumbs="[$t('menu.pendingRequisitions')]"></breadcrumb>
      </div>
      <div class="page-tabs">
        <router-link to="/normal/mms/pendings/orders" class="active"
          >订单<span v-if="pendingsOrderCount != 0"
            >({{ pendingsOrderCount }})</span
          ></router-link
        >
        <el-divider direction="vertical"></el-divider>
        <router-link to="/normal/mms/pendings/purchases"
          >外采单<span v-if="pendingsPurchaseCount != 0"
            >({{ pendingsPurchaseCount }})</span
          ></router-link
        >
      </div>
      <div><!-- 占位 --></div>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.serialNo"
            :placeholder="$t('order.serialNo')"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-autocomplete
            v-model="searchForm.customerName"
            :fetch-suggestions="queryCustomerName"
            :trigger-on-focus="false"
            @select="handleSelectCustomerName"
            size="small"
            :placeholder="$t('menu.customers')"
          >
          </el-autocomplete>
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.productNo"
            :placeholder="$t('product.productNo')"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.color"
            :placeholder="$t('product.color')"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="searchForm.factoryName"
            :placeholder="$t('menu.factories')"
            size="small"
            filterable
            clearable
          >
            <el-option
              v-for="factory in factories"
              :key="factory.id"
              :label="factory.name"
              :value="factory.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <sticky :sticky-top="50" :viewport="1024" :is-rem="false" class="sticky">
        <vxe-toolbar ref="recordsToolbar" custom zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-button
              v-if="
                Permit.canActionsChargeEdition('mmsPendingRequisitionsPicking')
              "
              type="primary"
              size="mini"
              @click="feed"
              >{{ $t("action.feed") }}</el-button
            >
            <el-button
              v-if="
                Permit.canActionsChargeEdition(
                  'mmsPendingRequisitionsPickingAndDirectFeed'
                )
              "
              type="success"
              size="mini"
              @click="give"
              >{{ $t("action.give") }}</el-button
            >
            <el-dropdown
              v-if="
                Permit.canActionsChargeEdition(
                  'mmsPendingRequisitionsCreateProcure'
                )
              "
              @command="createProcure"
              class="mgl10 mgr10"
            >
              <el-button type="warning" size="mini">
                {{ $t("action.applyPurchase") }}
                <i class="el-icon-caret-bottom el-icon--right" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="checked">
                  {{ $t("action.createProcureChecked") }}
                </el-dropdown-item>
                <el-dropdown-item command="search">
                  {{ $t("action.createProcureSearch") }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button
              v-if="Permit.canActions('mmsAccountiMaterial')"
              type="primary"
              size="mini"
              @click="accountiMaterials"
              class="button-blue"
              >{{ $t("menu.calculates") }}</el-button
            >
            <el-button
              type="default"
              size="mini"
              :loading="afreshMetrialDoing"
              @click="afreshMetrial"
              >{{ $t("action.afreshMetrial") }}</el-button
            >
            <el-button
              type="default"
              size="mini"
              :loading="virtualCreateProduceDoing"
              @click="virtualCreateProduce"
              >{{ $t("action.virtualCreateProduce") }}</el-button
            >
            <span class="pager-total">
              {{ $t("rules.pagerTotal", [pager.total]) }}
            </span>
          </template>
        </vxe-toolbar>
      </sticky>
      <vxe-table
        :data="records"
        @checkbox-change="setSelected"
        @checkbox-all="setSelected"
        @sort-change="sortRecords"
        :sort-config="{ remote: true }"
        :checkbox-config="{ reserve: true, checkMethod: checCheckboxMethod }"
        :custom-config="{ storage: true, checkMethod: checkColumnMethod }"
        :expand-config="{ lazy: true, loadMethod: loadContentMethod }"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        id="recordsTable"
        row-id="id"
        :loading="loading"
        resizable
        round
        highlight-hover-row
        auto-resize
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="checkbox"
          type="checkbox"
          width="35"
        ></vxe-table-column>

        <vxe-table-column type="expand" width="50">
          <template #content="{ row }">
            <div style="padding: 10px">
              <vxe-table
                resizable
                :ref="row.uuid"
                :row-id="row.uuid"
                :tree-config="{ transform: true, expandAll: true }"
                :data="row.detailList"
                @checkbox-change="expandSelectChangeEvent"
                @checkbox-all="
                  expandSelectChangeAllEvent(...arguments, row.detailList)
                "
                :checkbox-config="{
                  reserve: true,
                  checkMethod: expandChecCheckboxkMethod,
                  visibleMethod: expandShowCheckboxkMethod,
                }"
                :row-class-name="calculateBgColorExpand"
                size="mini"
              >
                <vxe-table-column type="checkbox" width="60" />
                <vxe-table-column
                  field="materialSerialNo"
                  :title="$t('material.serialNo')"
                ></vxe-table-column>
                <vxe-table-column
                  field="materialName"
                  :title="$t('material.name')"
                  min-width="100"
                />
                <vxe-table-column
                  field="color"
                  :title="$t('material.color')"
                  min-width="100"
                />
                <vxe-table-column
                  field="colorNo"
                  :title="$t('material.colorNo')"
                  min-width="100"
                />
                <vxe-table-column
                  field="quantity"
                  :title="$t('material.quantity')"
                  min-width="80"
                >
                  <template v-slot="{ row }">
                    {{ row.quantity }}{{ row.unit }}
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="requisitionId"
                  :title="$t('giveInfos.yes')"
                  min-width="80"
                >
                  <template v-slot="{ row }">
                    <span v-if="row.requisitionId != null">
                      {{ $t("boolean.true") }}
                    </span>
                  </template>
                </vxe-table-column>
              </vxe-table>
            </div>
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="85"
        >
          <template v-slot="{ row }">
            <thumbnail :images="row.images"></thumbnail>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="serialNo"
          :title="$t('order.serialNo')"
          min-width="130"
        >
          <template v-slot="{ row }">
            <small v-if="row.hurry" class="red">
              ({{ $t("order.hurrySimple") }})
            </small>
            <a @click="showRecord(row)">
              {{ row.serialNo }}
            </a>
            <div class="font10">{{ row.innerSerialNo }}</div>
            <div>
              <state-label :state="row.workflowState">{{
                $t("orderStates." + row.workflowState)
              }}</state-label>
              <span class="font10">
                <span v-if="row.calcMaterialAt == null" class="red">{{
                  $t("productMixStates.unMix")
                }}</span>
                <span v-if="row.calcMaterialAt != null" class="green">{{
                  $t("productMixStates.mixed")
                }}</span>
              </span>
            </div>
            <div class="font10">{{ row.factoryName }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.productNo }}
            <small
              v-if="
                row.customerProductNo != null && row.customerProductNo != ''
              "
              >({{ row.customerProductNo }})</small
            >
            <div class="font10">
              {{ row.categoryName }}
              <span v-if="row.productBrand != null">/</span>
              {{ row.productBrand }}
            </div>
            <div class="font10">{{ row.color }} {{ row.size }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          min-width="60"
        >
          <template v-slot="{ row }">
            {{ row.quantity }}{{ row.unit }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="handOverAt"
          :title="$t('text.handOverAt')"
          min-width="110"
        ></vxe-table-column>
        <vxe-table-column
          field="createAt"
          :title="$t('text.createAt')"
          min-width="110"
        />
        <vxe-table-column
          field="takeMaterialAt"
          :title="$t('pendingRequisition.takeMaterialAt')"
          min-width="110"
        />
        <vxe-table-column
          field="subjectsJson"
          :title="$t('pendingRequisition.subjectsJson')"
          min-width="80"
        >
          <template v-slot="{ row }">
            <span
              v-if="row.subjectsJson != null && row.subjectsJson != ''"
              class="font10"
            >
              {{ JSON.parse(row.subjectsJson).join(",") }}
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="giveFinishAt"
          :title="$t('procure.finishAt')"
          min-width="110"
        />
        <vxe-table-column
          field="mmsCreateProcureAt"
          :title="$t('pendingRequisition.createProcureAt')"
          min-width="120"
        />

        <vxe-table-column
          field="remark"
          :title="$t('text.remark')"
          min-width="80"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number
              :content="row.remark"
              :number="6"
              type="richText"
            />
            <div>
              <attribute :content="row.specJson" :number="6" />
            </div>
          </template>
        </vxe-table-column>

        <vxe-table-column
          v-if="
            Permit.canActionsChargeEdition('mmsPendingRequisitionsPicking') ||
            Permit.canActionsChargeEdition(
              'mmsPendingRequisitionsPickingAndDirectFeed'
            )
          "
          field="action"
          :title="$t('text.action')"
          width="70"
          fixed="right"
        >
          <template v-slot="{ row }">
            <el-button
              v-if="row.giveFinishAt == null"
              type="text"
              size="mini"
              :loading="ignoreFeedDoing"
              @click="ignoreFeed(row)"
              >{{ $t("action.ignoreFeed") }}</el-button
            >
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }} </span>条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>
    <drawer
      :title="$t('text.view')"
      :visible.sync="showDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show :id="currentRowId" @updateInfo="showClose" />
    </drawer>

    <!-- 生成发料单 -->
    <el-dialog
      :title="$t('action.feed')"
      :close-on-click-modal="false"
      :visible.sync="feedDF"
      width="50%"
    >
      <div class="center mgb15">
        <el-input
          size="small"
          v-model.trim="scanSerialNo"
          :placeholder="$t('order.serialNo')"
          style="width: 300px"
          autofocus
          @keypress.enter.native="feedSerialNoEnterKeyUp"
        />
      </div>
      <div class="mgb10">
        {{ $t("requisition.manageSubjects") }}：
        <span
          v-for="(ms, index) of manageSubjects"
          :key="index"
          class="mgb10 mgr10"
          >{{ ms.name }}</span
        >
      </div>
      <el-form ref="feedForm" :model="feedObj">
        <div class="mgb15">
          <vxe-table
            :data="checkAndScanRecords"
            size="mini"
            highlight-hover-row
            :scroll-y="{ enabled: false }"
          >
            <vxe-table-column
              field="images"
              :title="$t('product.images')"
              width="85"
            >
              <template v-slot="{ row }">
                <thumbnail :images="row.images"></thumbnail>
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="serialNo"
              :title="$t('text.serialNo')"
              min-width="130"
            >
              <template v-slot="{ row }">
                <small v-if="row.hurry" class="red">
                  ({{ $t("order.hurrySimple") }})
                </small>
                {{ row.serialNo }}
                <div class="font10">{{ row.innerSerialNo }}</div>
                <div>
                  <state-label :state="row.workflowState">{{
                    $t("orderStates." + row.workflowState)
                  }}</state-label>
                  <span class="font10">
                    <span v-if="row.calcMaterialAt == null" class="red">{{
                      $t("productMixStates.unMix")
                    }}</span>
                    <span v-if="row.calcMaterialAt != null" class="green">{{
                      $t("productMixStates.mixed")
                    }}</span>
                  </span>
                </div>
                <div class="font10">{{ row.factoryName }}</div>
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="productNo"
              :title="$t('product.productNo')"
              min-width="100"
            >
              <template v-slot="{ row }">
                {{ row.productNo }}
                <small
                  v-if="
                    row.customerProductNo != null && row.customerProductNo != ''
                  "
                  >({{ row.customerProductNo }})</small
                >
                <div class="font10">
                  {{ row.categoryName }}
                  <span v-if="row.productBrand != null">/</span>
                  {{ row.productBrand }}
                </div>
                <div class="font10">{{ row.color }} {{ row.size }}</div>
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="quantity"
              :title="$t('text.quantity')"
              min-width="60"
            >
              <template v-slot="{ row }">
                {{ row.quantity }}{{ row.unit }}
              </template>
            </vxe-table-column>

            <vxe-table-column
              field="action"
              :title="$t('text.action')"
              width="50"
            >
              <template v-slot="{ row, rowIndex }">
                <el-button
                  type="text"
                  size="small"
                  @click="removeFeed(row, rowIndex)"
                  >{{ $t("text.remove") }}</el-button
                >
              </template>
            </vxe-table-column>
          </vxe-table>
        </div>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label-width="80px"
              :label="$t('requisition.dept')"
              :prop="'dept'"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('requisition.dept')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-input size="small" v-model.trim="feedObj.dept" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label-width="80px"
              :label="$t('text.remark')"
              :prop="'remark'"
            >
              <el-input
                size="small"
                v-model.trim="feedObj.remark"
                :placeholder="$t('text.remark')"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!-- <el-checkbox v-if="isLinkDF" size="small" v-model="feedObj._isLink">
          {{ $t("requisition.isLink") }}
        </el-checkbox> -->
        <el-button
          :class="isLinkDF == true ? 'mgl10' : ''"
          type="primary"
          plain
          :loading="feedDoing"
          size="small"
          @click="feedSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="feedDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <!-- 生成物料采购单 -->
    <el-dialog
      :title="$t('action.applyPurchase')"
      :close-on-click-modal="false"
      :visible.sync="createProcureDF"
      width="50%"
    >
      <div class="mgb15">
        {{ $t("requisition.manageSubjects") }}：
        <span
          v-for="(ms, index) of manageSubjects"
          :key="index"
          class="mgb10 mgr10"
          >{{ ms.name }}</span
        >
      </div>

      <div class="center mgb15">
        <el-input
          size="small"
          v-model.trim="scanSerialNo"
          :placeholder="$t('order.serialNo')"
          style="width: 300px"
          autofocus
          @keypress.enter.native="createProcureSerialNoEnterKeyUp"
        />
      </div>

      <el-form ref="createProcureForm" :model="createProcureObj">
        <div class="mgb15">
          <vxe-table
            :data="checkAndScanRecords"
            size="mini"
            highlight-hover-row
            :scroll-y="{ enabled: false }"
          >
            <vxe-table-column
              field="images"
              :title="$t('product.images')"
              width="85"
            >
              <template v-slot="{ row }">
                <thumbnail :images="row.images"></thumbnail>
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="serialNo"
              :title="$t('text.serialNo')"
              min-width="130"
            >
              <template v-slot="{ row }">
                <small v-if="row.hurry" class="red">
                  ({{ $t("order.hurrySimple") }})
                </small>
                {{ row.serialNo }}
                <div class="font10">{{ row.innerSerialNo }}</div>
                <div>
                  <state-label :state="row.workflowState">{{
                    $t("orderStates." + row.workflowState)
                  }}</state-label>
                  <span class="font10">
                    <span v-if="row.calcMaterialAt == null" class="red">{{
                      $t("productMixStates.unMix")
                    }}</span>
                    <span v-if="row.calcMaterialAt != null" class="green">{{
                      $t("productMixStates.mixed")
                    }}</span>
                  </span>
                </div>
                <div class="font10">{{ row.factoryName }}</div>
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="productNo"
              :title="$t('product.productNo')"
              min-width="100"
            >
              <template v-slot="{ row }">
                {{ row.productNo }}
                <small
                  v-if="
                    row.customerProductNo != null && row.customerProductNo != ''
                  "
                  >({{ row.customerProductNo }})</small
                >
                <div class="font10">
                  {{ row.categoryName }}
                  <span v-if="row.productBrand != null">/</span>
                  {{ row.productBrand }}
                </div>
                <div class="font10">{{ row.color }} {{ row.size }}</div>
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="quantity"
              :title="$t('text.quantity')"
              min-width="60"
            >
              <template v-slot="{ row }">
                {{ row.quantity }}{{ row.unit }}
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="mmsCreateProcureAt"
              :title="$t('pendingRequisition.createProcureAt')"
              min-width="120"
            />
            <vxe-table-column
              field="action"
              :title="$t('text.action')"
              width="50"
            >
              <template v-slot="{ row, rowIndex }">
                <el-button
                  type="text"
                  size="small"
                  @click="removeCreateProcure(row, rowIndex)"
                  >{{ $t("text.remove") }}</el-button
                >
              </template>
            </vxe-table-column>
          </vxe-table>
        </div>
        <el-row>
          <el-col :span="12">
            <el-form-item
              :label="$t('text.handOverAt')"
              :prop="'handOverAt'"
              label-width="80px"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('text.handOverAt')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-date-picker
                size="small"
                v-model="createProcureObj.handOverAt"
                type="date"
                style="width: 100%"
                :picker-options="pickerTodayAfterTime"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :prop="'remark'"
              :label="$t('text.remark')"
              label-width="80px"
            >
              <el-input
                size="small"
                v-model.trim="createProcureObj.remark"
                :placeholder="$t('text.remark')"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="createProcureDoing"
          size="small"
          @click="createProcureSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="createProcureDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="$t('action.applyPurchase')"
      :close-on-click-modal="false"
      :visible.sync="createProcureSearchDF"
      width="30%"
    >
      <div class="mgb15">
        {{ $t("requisition.manageSubjects") }}：
        <span
          v-for="(ms, index) of manageSubjects"
          :key="index"
          class="mgb10 mgr10"
          >{{ ms.name }}</span
        >
      </div>
      <el-form ref="createProcureSearchForm" :model="createProcureObj">
        <el-form-item
          :label="$t('text.handOverAt')"
          :prop="'handOverAt'"
          label-width="80px"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('text.handOverAt')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-date-picker
            size="small"
            v-model="createProcureObj.handOverAt"
            type="date"
            style="width: 100%"
            :picker-options="pickerTodayAfterTime"
          />
        </el-form-item>
        <el-form-item
          :prop="'remark'"
          :label="$t('text.remark')"
          label-width="80px"
        >
          <el-input
            size="small"
            v-model.trim="createProcureObj.remark"
            :placeholder="$t('text.remark')"
            type="textarea"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="createProcureSearchDoing"
          size="small"
          @click="createProcureSearchSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="createProcureSearchDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 发料 -->
    <el-dialog
      :title="$t('action.give')"
      :visible.sync="giveDF"
      v-if="giveDF"
      :close-on-click-modal="false"
      width="60%"
    >
      <div class="mgb15">
        {{ $t("requisition.manageSubjects") }}：
        <span
          v-for="(ms, index) of manageSubjects"
          :key="index"
          class="mgb10 mgr10"
          >{{ ms.name }}</span
        >
      </div>

      <el-form ref="giveObjForm" :model="giveObj" label-width="60px">
        <el-row>
          <el-col :span="8">
            <el-form-item
              :prop="'_warehouseId'"
              :label="$t('menu.warehouses')"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('menu.warehouses')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-select
                size="small"
                v-model.trim="giveObj._warehouseId"
                filterable
                @change="selectGiveWarehouse"
              >
                <el-option
                  v-for="warehouse in mmsAuthWarehouses"
                  :key="warehouse.id"
                  :label="warehouse.name"
                  :value="warehouse.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label-width="80px"
              :label="$t('requisition.dept')"
              :prop="'dept'"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('requisition.dept')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-input size="small" v-model.trim="giveObj.dept" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('text.remark')" :prop="'remark'">
              <el-input
                size="small"
                v-model.trim="giveObj.remark"
                :placeholder="$t('text.remark')"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <vxe-table
          resizable
          :tree-config="{ transform: true, expandAll: true }"
          :data="pendingFeedMaterialsGroup"
          size="mini"
          class="mgb10"
        >
          <vxe-table-column
            field="serialNo"
            :title="$t('material.serialNo')"
            min-width="100"
          >
            <template v-slot="{ row }">
              <span v-if="row.isMerge">{{ row.subjectName }}</span>
              <span v-else>
                <span v-if="row.material != null">
                  {{ row.material.serialNo }}
                </span>
              </span>
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="name"
            :title="$t('material.name')"
            min-width="100"
          >
            <template v-slot="{ row }">
              <span v-if="row.material != null">
                {{ row.material.name }}
              </span>
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="color"
            :title="$t('material.color')"
            min-width="100"
          >
            <template v-slot="{ row }">
              <span v-if="row.material != null">
                {{ row.material.color
                }}<small>({{ row.material.colorNo }})</small>
              </span>
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="quantity"
            :title="$t('material.quantity')"
            min-width="80"
          >
            <template v-slot="{ row }">
              {{ row.quantity }}
              <span v-if="row.material != null">{{ row.material.unit }}</span>
            </template>
          </vxe-table-column>

          <vxe-table-column
            field="_giveQuantity"
            :title="$t('material.invDiffQuantity')"
            min-width="80"
          >
            <template v-slot="{ row }">
              <el-input
                v-if="!row.isMerge"
                size="small"
                v-model.trim="row._giveQuantity"
              ></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="_giveCashQuantity"
            :title="$t('material.giveCashQuantity')"
            min-width="80"
          >
            <template v-slot="{ row }">
              <el-input
                v-if="!row.isMerge"
                size="small"
                v-model.trim="row._giveCashQuantity"
              ></el-input>
            </template>
          </vxe-table-column>

          <vxe-table-column
            field="inventories"
            :title="$t('inventory.invCashQuantity')"
            min-width="120px"
          >
            <template v-slot="{ row }">
              <span v-if="row.inventories != null">
                <div v-for="i of row.inventories" :key="i.id" class="font10">
                  {{ i.warehouseName }}({{ i.shelf }})&nbsp; {{ i.storeQuantity
                  }}{{ row.unit }}/{{ i.cashQuantity }}{{ row.unit }}
                </div>
              </span>
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="action"
            :title="$t('text.action')"
            width="100px"
          >
            <template v-slot="{ row, rowIndex }">
              <el-popconfirm
                :title="$t('prompt.confirmRemove')"
                @confirm="removeRow(row, rowIndex)"
              >
                <el-button slot="reference" type="text" size="mini">
                  {{ $t("text.remove") }}
                </el-button>
              </el-popconfirm>
              <template v-if="!row.isMerge">
                <div class="font8 red" v-if="row._invNotExistDF">
                  库存不存在
                </div>
                <div class="font8 red" v-if="row._invNotEnoughDF">
                  库存数量不足
                </div>
              </template>
            </template>
          </vxe-table-column>
        </vxe-table>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="giveSubmitDoing"
          size="small"
          @click="giveSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="giveDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import XEUtils from "xe-utils";
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import Show from "./show.vue";
import Order from "@/api/order.js";
import Requisition from "@/api/requisition.js";
import Subject from "@/api/subject.js";
import Warehouse from "@/api/warehouse.js";
import UserWarehouse from "@/api/userWarehouse.js";
import Procure from "@/api/procure.js";
import OrderMaterial from "@/api/orderMaterial.js";
import Material from "@/api/material.js";
import Customer from "@/api/customer.js";
import Factory from "@/api/factory.js";
import Purchase from "@/api/purchase.js";

export default {
  mixins: [
    page,
    table.pager,
    table.search,
    table.narrow,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    Show,
  },
  data() {
    return {
      pickerTodayAfterTime: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      narrows: [
        [
          {
            label: this.$t("pendingRequisition.giveInfo"),
            items: [
              {
                label: this.$t("giveInfos.no"),
                key: "no",
                condition: { giveFinish: "no" },
              },
              {
                label: this.$t("giveInfos.part"),
                key: "part",
                condition: { giveFinish: "part" },
              },
              {
                label: this.$t("giveInfos.yes"),
                key: "yes",
                condition: { giveFinish: "yes" },
              },
            ],
          },
          {
            label: this.$t("pendingRequisition.calcMaterialAt"),
            items: [
              {
                label: this.$t("productMixStates.mixed"),
                key: "calcMaterialYes",
                condition: { calcMaterial: "yes" },
              },
              {
                label: this.$t("productMixStates.unMix"),
                key: "calcMaterialNo",
                condition: { calcMaterial: "no" },
              },
            ],
          },
          {
            label: this.$t("pendingRequisition.createProcureInfo"),
            items: [
              {
                label: this.$t("createProcureInfos.yes"),
                key: "createProcureAtYes",
                condition: { mmsCreateProcureAt: "yes" },
              },
              {
                label: this.$t("createProcureInfos.no"),
                key: "createProcureAtNo",
                condition: { mmsCreateProcureAt: "no" },
              },
            ],
          },
        ],
      ],
      initFilter: null,
      searchForm: {
        serialNo: null,
        customerName: null,
        productNo: null,
        color: null,
        factoryName: null,
      },
      sorter: {
        sortBy: "orders_id",
        sortIndicator: "desc",
      },
      custmers: [],
      //
      currentRowId: null,
      showDF: false,
      //
      ignoreFeedDoing: false,
      subjects: [],
      manageSubjects: [],
      warehouses: [],
      userWarehouses: [],
      mmsAuthWarehouses: [],

      // 生成发料单
      feedDF: false,
      feedObj: {
        remark: null,
        requisitionOrders: [],
        type: "Order",
        _isLink: false,
        dept: null,
      },
      feedDoing: false,
      isLinkDF: false,
      scanSerialNo: null,
      checkAndScanRecords: [],

      // 生成物料采购单
      createProcureDF: false,
      createProcureObj: {
        uuids: [],
        handOverAt: null,
        remark: null,
        procureOrders: [],
      },
      createProcureDoing: false,
      //
      createProcureSearchDF: false,
      createProcureSearchDoing: false,
      //
      afreshMetrialDoing: false,
      //
      virtualCreateProduceDoing: false,
      //=发料
      selectedOrderMaterials: [],
      pendingFeedMaterials: [],
      pendingFeedMaterialsGroup: [],
      giveDF: false,
      giveObj: {
        type: "Order",
        dept: null,
        remark: null,
        _warehouseId: null,
        feedMaterials: [],
      },
      giveSubmitDoing: false,
      //
      factories: [],
      //
      pendingsOrderCount: 0,
      pendingsPurchaseCount: 0,
    };
  },
  created() {
    const self = this;
    this.$nextTick(() => {
      this.$refs.recordsTable.connect(this.$refs.recordsToolbar);
    });
    axios.all([Subject.findByTenantId(), Factory.findByTenantId()]).then(
      axios.spread(function (subjects, factories) {
        self.subjects = subjects.data;

        if (self.Permit.currentUser().admin === true) {
          self.manageSubjects = self.subjects;
        } else {
          self.manageSubjects = self.subjects.filter((s) =>
            self.Permit.mmsAuthSubjuctIds().includes(s.id)
          );
        }

        if (factories.status === 200) {
          self.factories = factories.data;
        } else {
          self.sysError();
        }

        self.getPendingsOrderCountCount();
        self.getPendingsPurchaseCountCount();
      })
    );
  },
  methods: {
    getPendingsOrderCountCount() {
      const self = this;
      Order.pendingRequisitionsCount().then(function (res) {
        if (res.status === 200) {
          self.pendingsOrderCount = res.data;
        } else {
          self.sysError();
        }
      });
    },
    getPendingsPurchaseCountCount() {
      const self = this;
      Purchase.pendingRequisitionsCount().then(function (res) {
        if (res.status === 200) {
          self.pendingsPurchaseCount = res.data;
        } else {
          self.sysError();
        }
      });
    },
    //发料
    give() {
      const self = this;
      if (
        self.selectRecords.length === 0 &&
        self.selectedOrderMaterials.length == 0
      ) {
        self.$message({
          message: "至少选择一条订单或者一条物料信息",
          type: "warning",
        });
        return;
      }
      self.giveObj.dept = null;
      self.giveObj.remark = null;
      self.giveObj._warehouseId = null;
      self.giveObj.feedMaterials = [];
      let obj = {
        orderUuids: [],
        orderMatierialIds: self.selectedOrderMaterials.map((s) => s.id),
      };
      for (const c of self.selectRecords) {
        if (
          self.selectedOrderMaterials.findIndex(
            (sOrderMaterial) => sOrderMaterial.orderUuid == c.uuid
          ) == -1
        ) {
          obj.orderUuids.push(c.uuid);
        }
      }
      self.pendingFeedMaterials = [];
      self.pendingFeedMaterialsGroup = [];
      OrderMaterial.beforeFeedCalc(obj).then(function (res) {
        if (res.status == 200) {
          self.pendingFeedMaterials = res.data;
          // console.log("===", self.pendingFeedMaterials);
          let subjectIds = self.pendingFeedMaterials.map((m) => m.subjectId);
          let subjectIdsSet = [...new Set(subjectIds)];
          for (let id of subjectIdsSet) {
            let tempMaterial = self.pendingFeedMaterials.filter(
              (m) => m.subjectId == id
            );
            let obj = {
              id: id,
              parentId: null,
              subjectId: id,
              subjectName: tempMaterial[0].subjectName,
              serialNo: tempMaterial[0].subjectName,
              isMerge: true,
              children: tempMaterial,
            };
            self.pendingFeedMaterialsGroup.push(obj);
            for (let material of tempMaterial) {
              Vue.set(material, "parentId", id);
              Vue.set(material, "_giveQuantity", material.quantity);
              Vue.set(material, "_giveCashQuantity", 0);
              Vue.set(material, "_invNotExistDF", false);
              Vue.set(material, "_invNotEnoughDF", false);
              Vue.set(material, "_invId", null);
              self.pendingFeedMaterialsGroup.push(material);
            }
          }

          self.getWarehouses();
          self.giveSubmitDoing = false;
          self.giveDF = true;
        } else {
          self.sysError();
        }
      });
    },
    // 移除
    removeRow(row, rowIndex) {
      const self = this;
      if (row.isMerge) {
        this.pendingFeedMaterialsGroup = this.pendingFeedMaterialsGroup.filter(
          (m) => m.subjectId != row.subjectId
        );
      } else {
        this.pendingFeedMaterialsGroup = this.pendingFeedMaterialsGroup.filter(
          (p) => p.materialId !== row.materialId
        );
      }
    },
    selectGiveWarehouse() {
      const self = this;
      for (const m of self.pendingFeedMaterialsGroup) {
        if (!m.isMerge) {
          m._invNotExistDF = false;
          m._invNotEnoughDF = false;
          let invObj = m.inventories.find(
            (i) => i.warehouseId == self.giveObj._warehouseId
          );
          if (invObj == null) {
            m._invNotExistDF = true;
            continue;
          }
          let totalQuantity = invObj.storeQuantity + invObj.cashQuantity;
          if (m.quantity > totalQuantity) {
            m._invNotEnoughDF = true;
            continue;
          }
          if (invObj.cashQuantity > m.quantity) {
            m._giveCashQuantity = m.quantity;
            m._giveQuantity = 0;
          } else {
            m._giveCashQuantity = invObj.cashQuantity;
            m._giveQuantity = m.quantity - m._giveCashQuantity;
          }
          m._invId = invObj.id;
        }
      }
    },
    giveSubmit() {
      const self = this;
      this.$refs.giveObjForm.validate((valid) => {
        if (valid) {
          self.giveObj.feedMaterials = [];
          for (const m of self.pendingFeedMaterialsGroup) {
            if (!m.isMerge) {
              if (m._invNotEnoughDF || m._invNotExistDF) {
                self.$message({
                  message: this.$t("prompt.errorMessage"),
                  type: "warning",
                });
                return;
              }
              self.giveObj.feedMaterials.push({
                materialId: m.materialId,
                materialSerialNo:
                  m.material != null ? m.material.serialNo : null,
                materialName: m.material != null ? m.material.name : null,
                subjectId: m.subjectId,
                subjectName: m.subjectName,
                linkIds: m.linkIds,
                invId: m._invId,
                quantity: m.quantity,
                giveQuantity: m._giveQuantity,
                giveCashQuantity: m._giveCashQuantity,
              });
            }
          }
          // console.log("===== self.giveObj", self.giveObj);
          self.giveSubmitDoing = true;
          Requisition.directFeedOrderMatierials(self.giveObj).then(function (
            res
          ) {
            if (res.status == 200) {
              self.sysResults(res.data);
              self.loadData();
              self.giveDF = false;
              self.giveSubmitDoing = false;
              self.$eventHub.$emit("RequisitionDirectFeedOrderMatierials");
              self.getPendingsOrderCountCount();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    //==============
    loadContentMethod({ row }) {
      const self = this;
      return new Promise((resolve) => {
        OrderMaterial.findByOrderUuid({ orderUuid: row.uuid }).then(function (
          res
        ) {
          if (res.status === 200) {
            const orderMaterials = res.data;

            let result = [];
            let subjectIds = orderMaterials.map((m) => m.subjectId);
            let subjectIdsSet = [...new Set(subjectIds)];
            for (let id of subjectIdsSet) {
              let tempMaterial = orderMaterials.filter(
                (m) => m.subjectId == id
              );
              let obj = {
                id: id,
                parentId: null,
                subjectId: id,
                materialSerialNo: tempMaterial[0].subjectName,
                isMerge: true,
                children: tempMaterial,
              };
              result.push(obj);
              for (let material of tempMaterial) {
                Vue.set(material, "parentId", id);
                result.push(material);
              }
            }

            row.detailList = result;
            resolve();
          } else {
            row.detailList = [];
            resolve();
          }
        });
      });
    },
    expandSelectChangeEvent({ records, checked, row }) {
      if (checked) {
        let recordsFilter = records.filter((r) => !r.isMerge);
        for (const r of recordsFilter) {
          if (
            this.selectedOrderMaterials.findIndex((s) => s.id == r.id) == -1
          ) {
            this.selectedOrderMaterials.push(r);
          }
        }
      } else {
        if (row.isMerge) {
          for (const c of row.children) {
            this.selectedOrderMaterials = this.selectedOrderMaterials.filter(
              (s) => s.id !== c.id
            );
          }
        } else {
          this.selectedOrderMaterials = this.selectedOrderMaterials.filter(
            (s) => s.id !== row.id
          );
        }
      }
      // console.log("===finel", this.selectedOrderMaterials);
    },
    expandSelectChangeAllEvent({ records, checked }, data) {
      if (checked) {
        let recordsFilter = records.filter((r) => !r.isMerge);
        for (const r of recordsFilter) {
          if (
            this.selectedOrderMaterials.findIndex((s) => s.id == r.id) == -1
          ) {
            this.selectedOrderMaterials.push(r);
          }
        }
      } else {
        for (const d of data) {
          for (const c of d.children) {
            this.selectedOrderMaterials = this.selectedOrderMaterials.filter(
              (s) => s.id !== c.id
            );
          }
        }
      }
      // console.log("===all", this.selectedOrderMaterials);
    },
    expandChecCheckboxkMethod({ row }) {
      let manageSubjectsDF = this.manageSubjects
        .map((s) => s.id)
        .includes(Number(row.subjectId));
      if (row.isMerge) {
        const unGivedChildren = row.children.filter(
          (c) => c.requisitionId == null
        );
        return manageSubjectsDF && unGivedChildren.length > 0;
      } else {
        return manageSubjectsDF && row.requisitionId == null;
      }
    },
    expandShowCheckboxkMethod({ row }) {
      return !row.isMerge && row.requisitionId == null;
    },
    calculateBgColorExpand({ row, rowIndex }) {
      return row.isMerge ? "light-blue-bg" : "";
    },
    //===============
    virtualCreateProduce() {
      const self = this;
      self.virtualCreateProduceDoing = true;
      Procure.virtualCreateProduceByOrder({
        uuids: self.selectRecords.map((c) => c.uuid),
      }).then(function (res) {
        self.virtualCreateProduceDoing = false;
        if (res.status == 200) {
          self.$message({
            message: self.$t("prompt.virtualCreateProduceSucess"),
            type: "success",
          });
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
    //
    queryCustomerName(queryString, cb) {
      const self = this;
      if (queryString == null || queryString.length < 1) {
        return;
      }
      Customer.vagueFindByName({ name: queryString }).then(function (res) {
        const ps = res.data;
        ps.forEach((p) => (p.value = p.name));
        self.customers = ps;
        cb(self.customers);
      });
    },
    handleSelectCustomerName(item) {
      const self = this;
      self.searchForm.customerName = item.name;
    },
    getWarehouses() {
      const self = this;
      axios
        .all([
          Warehouse.findByTenantId(),
          UserWarehouse.findByUserId(self.Permit.currentUser().id),
        ])
        .then(
          axios.spread(function (warehouses, userWarehouses) {
            self.warehouses = warehouses.data;
            self.userWarehouses = userWarehouses.data;
            if (self.Permit.currentUser().admin) {
              self.mmsAuthWarehouses = self.warehouses;
            } else {
              const userWarehouseIds = self.userWarehouses.map(
                (u) => u.warehouseId
              );
              self.mmsAuthWarehouses = self.warehouses.filter((w) =>
                userWarehouseIds.includes(w.id)
              );
            }
          })
        );
    },
    // 用料核算
    accountiMaterials() {
      const self = this;
      if (self.selectRecords.length === 0) {
        self.$message({
          message: this.$t("prompt.atLeastOneData"),
          type: "warning",
        });
        return;
      }
      const data = {
        type: "Order",
        uuids: self.selectRecords.map((c) => c.uuid),
      };
      Material.statistics(data).then(function (res) {
        if (res.status === 200) {
          if (res.data.length === 0) {
            self.$message({
              message: "暂无生成算料的数据",
              type: "warning",
            });
          } else {
            self.$router.push({
              name: "mmsCalculates",
              query: data,
            });
          }
        } else {
          self.sysError();
        }
      });
    },

    // 重新获取配料
    afreshMetrial() {
      const self = this;
      if (this.selectRecords.length === 0) {
        this.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      const data = JSON.parse(JSON.stringify(self.selectRecords)).filter(
        (c) => c.takeMaterialAt == null
      );
      if (data.length === 0) {
        this.$message.error(this.$t("prompt.atLeastOneValidData"));
        return;
      }
      self.afreshMetrialDoingDoing = true;
      OrderMaterial.afresh(data.map((d) => d.uuid)).then(function (res) {
        self.afreshMetrialDoingDoing = false;
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.afreshMetrialSuccess"),
            type: "success",
          });
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
    // 生成物料采购单
    createProcure(cmd) {
      const self = this;
      if (cmd == "checked") {
        self.createProcureDoing = false;
        self.createProcureObj.remark = null;
        self.createProcureObj.handOverAt = null;
        self.checkAndScanRecords = [];
        self.checkAndScanRecords = JSON.parse(
          JSON.stringify(this.selectRecords)
        );
        self.createProcureDF = true;
      }
      if (cmd == "search") {
        self.createProcureObj.remark = null;
        self.createProcureObj.handOverAt = null;
        if ((self.combineParams().serialNo ?? "") == "") {
          self.$message({
            message: "必须用单号搜索",
            type: "warning",
          });
          return;
        }
        self.createProcureSearchDF = true;
      }
    },
    createProcureSerialNoEnterKeyUp() {
      const self = this;
      const obj = self.checkAndScanRecords.find(
        (c) => c.serialNo === self.scanSerialNo
      );
      if (obj == null) {
        Order.findBySerialNo({
          serialNo: Util.qrcodeAnalysis(self.scanSerialNo, "serialNo"),
        }).then(function (res) {
          if (res.data.code === 200) {
            const order = res.data.entity;
            if (order.takeMaterialAt != null) {
              self.$message({
                message: self.$t("prompt.serialNoHasTakeMaterial"),
                type: "warning",
              });
              return;
            }
            self.checkAndScanRecords.push(res.data.entity);
          } else {
            self.$message({
              message: self.$t("prompt.notExixtSerialNo"),
              type: "warning",
            });
          }
        });
      } else {
        self.$message({
          message: self.$t("prompt.exixtSerialNo"),
          type: "warning",
        });
      }
      self.scanSerialNo = null;
    },
    //
    removeCreateProcure(row, rowIndex) {
      this.checkAndScanRecords.splice(rowIndex, 1);
    },
    createProcureSubmit() {
      const self = this;
      if (this.checkAndScanRecords.length === 0) {
        this.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      const unMixRows = self.checkAndScanRecords.filter(
        (c) => c.calcMaterialAt == null
      );
      if (unMixRows.length != 0) {
        this.$message.error(this.$t("prompt.existUnMixRecords"));
        return;
      }
      this.$refs.createProcureForm.validate((valid) => {
        if (valid) {
          self.createProcureObj.uuids = this.checkAndScanRecords.map(
            (c) => c.uuid
          );
          self.createProcureObj.procureOrders = this.checkAndScanRecords.map(
            (c) => {
              return {
                orderUuid: c.uuid,
                orderSerialNo: c.serialNo,
                images: c.images,
                productNo: c.productNo,
                productId: c.productId,
                color: c.color,
                size: c.size,
                quantity: c.quantity,
                handOverAt: c.handOverAt,
              };
            }
          );
          self.createProcureObj.handOverAt =
            Util.formatDateTime(self.createProcureObj.handOverAt) + ":00";
          self.createProcureDoing = true;
          Procure.createProduceFromOrders(self.createProcureObj).then(function (
            res
          ) {
            if (res.status === 200) {
              self.createProcureDoing = false;
              self.createProcureDF = false;
              self.sysResult(res.data);
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    createProcureSearchSubmit() {
      const self = this;
      this.$refs.createProcureSearchForm.validate((valid) => {
        if (valid) {
          let obj = {
            handOverAt:
              Util.formatDateTime(self.createProcureObj.handOverAt) + ":00",
            remark: self.createProcureObj.remark,
            search4OP: self.combineParams(),
          };
          self.createProcureSearchDoing = true;
          Procure.createProduceFromSearchOrders(obj).then(function (res) {
            if (res.status === 200) {
              self.createProcureSearchDoing = false;
              self.createProcureSearchDF = false;
              self.sysResult(res.data);
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    feed() {
      const self = this;
      self.checkAndScanRecords = [];
      self.checkAndScanRecords = JSON.parse(JSON.stringify(this.selectRecords));
      self.feedObj.remark = null;
      self.feedObj.dept = self.computeDept();
      // self.pickingJudgeExistUnMixOrders();
      self.feedDoing = false;
      self.feedDF = true;
    }, // 生成发料单
    removeFeed(row, rowIndex) {
      this.checkAndScanRecords.splice(rowIndex, 1);
    },
    computeDept() {
      const self = this;
      const factoryNames = this.selectRecords.map((c) => c.factoryName);
      const factoryNamesSet = [
        ...new Set(factoryNames.filter((n) => n !== null)),
      ];
      return factoryNamesSet.length != 0 ? factoryNamesSet.join(",") : null;
    },
    // pickingJudgeExistUnMixOrders() {
    //   const self = this;
    //   const unMixRows = self.checkAndScanRecords.filter(
    //     (c) => c.calcMaterialAt == null
    //   );
    //   if (unMixRows.length === 0) {
    //     self.isLinkDF = false;
    //     self.feedObj._isLink = true;
    //   } else {
    //     self.isLinkDF = true;
    //     self.feedObj._isLink = false;
    //   }
    // },
    feedSerialNoEnterKeyUp() {
      const self = this;
      const obj = self.checkAndScanRecords.find(
        (c) => c.serialNo === self.scanSerialNo
      );
      if (obj == null) {
        Order.findBySerialNo({
          serialNo: Util.qrcodeAnalysis(self.scanSerialNo, "serialNo"),
        }).then(function (res) {
          if (res.data.code === 200) {
            const order = res.data.entity;
            if (order.takeMaterialAt != null) {
              self.$message({
                message: self.$t("prompt.serialNoHasTakeMaterial"),
                type: "warning",
              });
              return;
            }
            self.checkAndScanRecords.push(res.data.entity);
            // self.pickingJudgeExistUnMixOrders();
          } else {
            self.$message({
              message: self.$t("prompt.notExixtSerialNo"),
              type: "warning",
            });
          }
        });
      } else {
        self.$message({
          message: self.$t("prompt.exixtSerialNo"),
          type: "warning",
        });
      }
      self.scanSerialNo = null;
    },
    feedSubmit() {
      const self = this;
      if (this.checkAndScanRecords.length === 0) {
        this.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      const unMixRows = self.checkAndScanRecords.filter(
        (c) => c.calcMaterialAt == null
      );
      if (unMixRows.length != 0) {
        this.$message.error(this.$t("prompt.existUnMixRecords"));
        return;
      }
      this.$refs.feedForm.validate((valid) => {
        if (valid) {
          self.feedObj.requisitionOrders = this.checkAndScanRecords.map((c) => {
            return {
              orderUuid: c.uuid,
              orderSerialNo: c.serialNo,
              images: c.images,
              productNo: c.productNo,
              productId: c.productId,
              color: c.color,
              size: c.size,
              quantity: c.quantity,
              isLink: self.feedObj._isLink,
              handOverAt: c.handOverAt,
            };
          });
          self.feedDoing = true;
          Requisition.createByOrder(self.feedObj).then(function (res) {
            if (res.status == 200) {
              self.feedDoing = false;
              self.feedDF = false;
              self.$message({
                message: self.$t("prompt.feedSuccess"),
                type: "success",
              });
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    //
    ignoreFeed(row) {
      const self = this;
      self.ignoreFeedDoing = true;
      Requisition.batchIgnoreFeedOrder([row.uuid]).then(function (res) {
        self.ignoreFeedDoing = false;
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.ignoreFeedSuccess"),
            type: "success",
          });
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
    //
    showRecord(row) {
      this.currentRowId = row.id;
      this.showDF = true;
    },
    showClose() {
      this.loadData();
    },
    // 可选
    checCheckboxMethod({ row }) {
      if (row.takeMaterialAt == null) {
        return true;
      }
      return false;
    },
    //
    dataProvider(params) {
      return Order.pendingRequisitionSearch(params);
    },
  },
};
</script>

<style >
</style>